var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogOut(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0a1 1 0 100 2h11v20H10a1 1 0 100 2h12a1 1 0 001-1V1a1 1 0 00-1-1H10z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.293 6.293a1 1 0 011.414 0L17 12l-.001.048a.997.997 0 01-.292.66l-5 5a1 1 0 01-1.414-1.415L13.586 13H1a1 1 0 110-2h12.586l-3.293-3.293a1 1 0 010-1.414zM11.707 6.293L17 11.99a.997.997 0 00-.293-.698l-5-5z"
  })));
}
export default SvgLogOut;